export default "__VITE_ASSET__CJGQw1sX__"